import { gql } from '@apollo/client';

export const GET_ENTERPRISE_SUB_ACCOUNT_PROGRAMS = gql`
  query GetEnterpriseSubAccountPrograms {
    vm {
      enterpriseSubAccountPrograms {
        subTenantId
        programs {
          masterEntityId
          name
        }
      }
    }
  }
`;
